import { deviceUserInput } from '../inputs/device-user.input';
import { createForm } from '../releox-engine/form/FormGenerator';
import { FormInput } from '../releox-engine/form/FormInput';

const form: FormInput[] = [
  deviceUserInput.firstName,
  deviceUserInput.lastName,
  deviceUserInput.tag,
  deviceUserInput.identifier,
];

export const deviceUserInfoForm = createForm(form);

export type DeviceUserInfoFormBody = {
  firstName: string;
  lastName: string;
  tag: string;
  identifier: string;
};
